module.exports = __webpack_public_path__ + "static/media/masthead-albany-advertiser.1cc8a2bb.png";